var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCohort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#EFEFFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.705 24.4677C26.0563 24.8182 26.0563 25.3867 25.705 25.7372C25.3536 26.0876 24.7835 26.0876 24.4321 25.7372L20.0006 21.2848L15.5376 25.7357C15.1863 26.0861 14.6162 26.0861 14.2648 25.7357C13.9134 25.3852 13.9134 24.8167 14.2648 24.4662L18.7292 20.0168L14.2635 15.5323C13.9122 15.1818 13.9122 14.6133 14.2635 14.2628C14.6149 13.9124 15.185 13.9124 15.5364 14.2628L20.0006 18.7489L24.4636 14.298C24.8149 13.9476 25.385 13.9476 25.7365 14.298C26.0879 14.6484 26.0878 15.217 25.7365 15.5674L21.272 20.0168L25.705 24.4677Z",
    fill: "#30307D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCohort);
export default __webpack_public_path__ + "static/media/close-cohort.a5cd1d453604a714e313fec1b840a818.svg";
export { ForwardRef as ReactComponent };